export const WEBHOOKS_API_BASE_URL = 'ui/organization/webhook';

export const webhooksQueryKeys = {
  all: [WEBHOOKS_API_BASE_URL],
};
